export function formatBetResponseMessage(value: unknown): string {
	if (typeof value === 'string') return value
	if (typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint') return String(value)

	if (isRecord(value)) {
		const message = getStringProperty(value, 'message') ?? getStringProperty(value, 'error') ?? getStringProperty(value, 'BF_MESSAGE')
		if (message) return message

		try {
			return JSON.stringify(value)
		} catch {
			return 'Unknown error'
		}
	}

	return 'Unknown error'
}

function isRecord(value: unknown): value is Record<string, unknown> {
	return typeof value === 'object' && value !== null
}

function getStringProperty(record: Record<string, unknown>, key: string): string | null {
	const value = record[key]
	return typeof value === 'string' && value.trim() ? value : null
}
